export const PageLoadingState = () => (
  <div className="bg-default h-screen w-screen flex justify-center items-center p-12">
    <div className="text-center">
      <h1 className="heading1 text-default mb-4">Loading info...</h1>
    </div>
  </div>
);
